<template lang="pug">
  v-dialog(
    v-model="model"
    :persistent="persistent")
    v-card(:loading="loading")
      v-card-title(
        style="word-break: break-word"
        :class="center ? `justify-center` : undefined") {{ title }}
      v-card-text {{ content }}
      v-card-actions(
        v-if="action1 || action2"
        :class="center ? `justify-center` : undefined")
        v-spacer(v-if="!center")
        v-btn(
          v-if="action2"
          text
          :disabled="loading"
          @click="onClick2") {{ action2.label }}
        v-btn(
          v-if="action1"
          color="primary"
          :disabled="loading"
          @click="onClick1") {{ action1.label }}
</template>

<script>
import { state } from '..'
import { toRefs, ref, computed } from '@vue/composition-api'

import { VDialog, VCard, VCardTitle, VCardText, VCardActions, VSpacer, VBtn } from 'vuetify/lib'

export default {
  components: {
    VDialog, VCard, VCardTitle, VCardText, VCardActions, VSpacer, VBtn
  },

  props: {
    center: Boolean
  },

  setup () {
    const loading = ref(false)
    const onClick1 = () => {
      const promise = state.action1?.onClick()
      if (promise?.then) {
        loading.value = true
        promise.then(() => {
          setTimeout(() => {
            loading.value = false
          }, 0)
        })
      }
    }
    const onClick2 = () => {
      const promise = state.action2?.onClick()
      if (promise?.then) {
        loading.value = true
        promise.then(() => {
          setTimeout(() => {
            loading.value = false
          }, 0)
        })
      }
    }

    return {
      ...toRefs(state),
      loading: computed(
        () => state.loading || loading.value
      ),
      onClick1,
      onClick2
    }
  }
}
</script>
